import { Notification } from "constant/notifications";
import React, { useEffect, useState } from "react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerErrorNotification,
  triggerSuccessNotification,
} from "utils/notification";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { updateFavorites } from "redux/userRedux";
import {
  favoriteAssest,
  PayloadObject,
} from "services/favorite/favoriteService";

function AddSongToFav({ song, Icon, musicCard, hover, favorite }: any) {
  // console.log(song);
  const dispatch = useDispatch<any>();
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const favoriteRedux = useSelector((state: any) => state?.user?.userFavorites);
  const [addFav, setAddFav] = useState<boolean>(false);

  useEffect(() => {
    const favoriteMusicIds = favoriteRedux?.favourite_music?.map(
      (item: any) => item.id,
    );
    if (song && favoriteMusicIds) {
      if (favoriteMusicIds?.includes(song?.id)) {
        setAddFav(true);
      } else {
        setAddFav(false);
      }
    }
  }, [favoriteRedux, song]);

  const addFavToRedux = () => {
    const updatedFavoriteMusic = [
      ...(favoriteRedux?.favourite_music || []),
      song,
    ];
    const updatedFavorite = {
      ...favoriteRedux,
      favourite_music: updatedFavoriteMusic,
    };
    // Dispatch the action to update the 'favorite' object in the Redux store
    dispatch(updateFavorites(updatedFavorite));
  };

  const removeFavFromRedux = () => {
    const updatedFavoriteMusic = favoriteRedux?.favourite_music?.filter(
      (favSong: any) => favSong.id !== song.id,
    );
    const updatedFavorite = {
      ...favoriteRedux,
      favourite_music: updatedFavoriteMusic,
    };
    // Dispatch the action to update the 'favorite' object in the Redux store
    dispatch(updateFavorites(updatedFavorite));
  };

  const handleFavorite = async (e: any) => {
    e.preventDefault();
    const favoriteSong: PayloadObject = {
      id: song.id,
      object_type: "song",
      is_favourite: true,
    };

    if (!addFav) {
      setAddFav(true);
      await favoriteAssest(favoriteSong)
        .then((res) => {
          if (res.status) {
            setAddFav(true);
            // updateFav();
            addFavToRedux();
            triggerSuccessNotification(Notification.AddToFav);
          } else {
            setAddFav(false);
            triggerErrorNotification(Notification.FavError);
          }
        })
        .catch((e) => {
          setAddFav(true);
          triggerErrorNotification(Notification.FavError);
        });
    } else {
      setAddFav(false);
      await favoriteAssest({
        id: song.id,
        object_type: "song",
        is_favourite: false,
      })
        .then((res) => {
          if (res.status) {
            triggerSuccessNotification(Notification.RemovedFromFav);
            // updateFav();
            removeFavFromRedux();
            setAddFav(false);
          } else {
            setAddFav(true);
            triggerErrorNotification(Notification.FavError);
          }
        })
        .catch((e) => {
          setAddFav(true);
          triggerErrorNotification(Notification.FavError);
        });
    }
  };
  return (
    <div>
      {loggedInUser ? (
        <div
          onClick={handleFavorite}
          className="cursor-pointer"
          data-tooltip-id={`add-song-to-favourite-${song?.id}`}
        >
          {addFav ? (
            <div className="text-red-600">
              {Icon ? (
                <AiFillHeart className="h-[18px] w-[18px] cursor-pointer" />
              ) : (
                <AiFillHeart />
              )}
            </div>
          ) : (
            <div
              className={
                musicCard
                  ? `${
                      hover
                        ? `text-red-600 duration-500 ease-in-out`
                        : `text-white duration-500 ease-in-out`
                    }`
                  : "text-white"
              }
            >
              {Icon ? (
                <AiOutlineHeart className="h-[18px] w-[18px] cursor-pointer" />
              ) : (
                <AiOutlineHeart />
              )}
            </div>
          )}

          <div className="text-sm">
            <ReactTooltip
              id={`add-song-to-favourite-${song?.id}`}
              place="top"
              content={addFav ? "Remove from favourite" : "Add to favourites"}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default AddSongToFav;
